// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"388":"64d542f5","720":"4b8dbdc9","871":"28318cb9"}[chunkId] + ".chunk.css";
};